import _uniqBy from 'lodash/uniqBy';
import sortWithCollation from './sortWithColation';

export default function sortedUniqItems(items, shouldReturnDuplicateFreeArray) {
	const itemsArray = shouldReturnDuplicateFreeArray ? _uniqBy(items, 'uuid') : items;
	return sortWithCollation(itemsArray, [item => item.name]).map(it => it.uuid);
}

export function uniqItems(items, shouldReturnDuplicateFreeArray) {
	const itemsArray = shouldReturnDuplicateFreeArray ? _uniqBy(items, 'uuid') : items;
	return itemsArray.map(it => it.uuid);
}

